import React from "react";
import { SALES_STATUS } from "@/lib/salesConstants";
import { cn } from "@/lib/utils";

export const SalesStatusBadge = ({ status, type, className, testId }) => {
  const key = type === "kreditnota" && status !== "kladd" && status !== "sanert" ? "kreditnota" : status;
  const s = key === "kreditnota" ? { label: "Kreditnota", cls: "status-mulig_duplikat" } : SALES_STATUS[status] || { label: status, cls: "status-avvist" };
  return (
    <span className={cn("inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap", s.cls, className)} data-testid={testId || `sales-status-${status}`}>
      {s.label}
    </span>
  );
};
